//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AnalysisResult",1,"TaggedObject",0],[0,"ColorPickerAbsent",1,0],[0,"ColorPickerChanged",1,0],[0,"ColorPickerNew",1,0],[0,"ColorPickerSame",1,0],[0,"CompareMethod",1,0],[0,"DeviationFloor",1,0],[0,"DoFidelityCompare",1,0],[0,"FloorRange",1,0],[0,"IsCompareDone",0,0],[0,"OptionMenu",1,0],[1,"SelectControlBody",0,"SelectBodyList",0],[1,"SelectSampleBody",0,"SelectBodyList",0],[0,"TessellationTolerance",1,0],[0,"TranslucentControl",1,0]],[[[],"UpdateControlBodiesToEngine",{},0,0],[[],"UpdateSampleBodiesToEngine",{},0,0],[["part"],"SetControlPart",{},1,0],[["part"],"SetSamplePart",{},1,0],[[],"CompareAction",{},0,0],[[],"ReportAction",{},0,0],[[],"RecreateVisualizer",{},0,0],[[],"PreVisualizationProcess",{},0,0],[[],"DisposeVisualization",{},0,0],[[],"CreateConvergentCompareStrategy",{},0,0],[[],"ClearAllComparedPairs",{},0,0],[["extractFeatures","controlBodies","sampleBodies"],"SetAnalysisResultDataFromBuilderData",{},3,0],[["nExtractedFeatures"],"ExtractControlBodiesToSamplePart",{R_:{extractedFeatures:"TaggedObject[]"}},0,0]],[]];
SPLM.GeometricUtilities.BodyCompareBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.BodyCompareBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.BodyCompareBuilder.CompareOptionType = Object.freeze({
    "Face" : "Face", "DistanceMap" : "DistanceMap"});

SPLM.GeometricUtilities.BodyCompareBuilder.FaceChangeCriteriaOption = Object.freeze({
    "Shape" : "Shape", "Edge" : "Edge", "Deviation" : "Deviation", "Any" : "Any"});

export default SPLM;